import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { markPORejected } from '../../redux/actions/purchaseOrders';

const DeletePOModal = ({ payload, showDeletePOModal, setShowDeletePOModal, purchaseOrder, rejectPo }) => {
  const update = () => {
    rejectPo(payload, purchaseOrder.id);
    setShowDeletePOModal(false);
  }

  return(
    <>
      { purchaseOrder &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowDeletePOModal(false),
            },
            { text: 'Reject PO', onClick: () => update() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Reject PO"
          isOpen={showDeletePOModal}
          onClose={() => setShowDeletePOModal(false)}
        >
          <H3>{purchaseOrder.invoice_number || purchaseOrder.id}</H3>
          <Text>Confirm that the remainder of outstanding items from this PO should be rejected, and the PO should be closed?</Text>
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  rejectPo: (payload, purchaseOrderId) => dispatch(markPORejected(payload, purchaseOrderId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeletePOModal);